import { render, staticRenderFns } from "./exam-room.vue?vue&type=template&id=6398a158&scoped=true&"
import script from "./exam-room.vue?vue&type=script&lang=js&"
export * from "./exam-room.vue?vue&type=script&lang=js&"
import style0 from "./exam-room.vue?vue&type=style&index=0&id=6398a158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398a158",
  null
  
)

export default component.exports